<template>
    <div>
      <div class="d-flex justify-content-end">
        <!-- <h5><b>Data List</b></h5> -->
        <div id="reportrange" class="table_customdate" >
              <date-range-picker
                ref="picker"
                :opens="left"
                v-model="dateRange"
                @update="updateValues"
                >
                <template v-slot:input="picker" style="min-width: 350px;">
                  {{  }} <i class="las la-calendar"></i> {{  }}
                </template>
                <template #ranges="ranges">
                  <div class="ranges">
                    <ul>
                      <li data-range-key v-for="(range, name) in ranges.ranges" :key="name" @click="ranges.clickRange(range)">{{ name == 'Last month' ? 'Custom' : name }}</li>
                    </ul>
                  </div>
                </template>
                <template #date="data">
                  <span class="small">{{ data.date | dateCell }}</span>
                </template>
              </date-range-picker>
          </div>
        </div>
              <datatable :columns="columns" :data="rows"></datatable>
              <datatable-pager v-model="page" type="abbreviated" :per-page="per_page"></datatable-pager>
        <div class="table_vue_part">
          <button class="btn btn-outline-primary excel_btn" @click="getPosts('start', 'end','excel')">Excel</button>

          <div class="table-responsive">
            <table class="table table-hover table-bordered" id="Datatable">
              <thead>
                <tr>
                  <th style="display:none;">Index</th>
                  <th>Code</th>
                  <th>Date</th>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Mobile No</th>
                  <th>Status</th>
                </tr>
            </thead>
            <tbody>
              <tr v-for="(user, index) in rows[0]" :key="user.id">
                <td style="display:none;">{{ index +1 }}</td>
                <td>{{user.code}}</td>
                <td>{{getDate(user.created_at)}}</td>
                <td>{{user.name}}</td>
                <td>{{user.email}}</td>
                <td>{{user.mobile}}</td>
                <td>
                    <div class="panel-body">
                    <label class="switch">
                      <input type="checkbox" @click="toggleCheckbox(user)" :checked="!user.status">
                      <div class="slider round"></div>
                    </label>
                    <!-- <p>{{ checkbox }}</p> -->
                  </div>

                </td>
              </tr>
            </tbody>
          </table>
          </div>


        </div>
    </div>
</template>
<script>
  import DateRangePicker from 'vue2-daterange-picker'
  import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'

  import "datatables.net-dt/js/dataTables.dataTables"
  import "datatables.net-dt/css/jquery.dataTables.min.css"
  import "datatables.net-buttons/js/dataTables.buttons.js"
  import "datatables.net-buttons/js/buttons.colVis.js"
  import "datatables.net-buttons/js/buttons.flash.js"
  import "datatables.net-buttons/js/buttons.html5.js"
  import "datatables.net-buttons/js/buttons.print.js"
  import $ from 'jquery';


  export default {

    props: ['slug'],

      name: "DataTableComponent",
      components: { DateRangePicker },


      data(){
          return {
            check: false,
              dateRange:{
                startDate: null,
                endDate: null,
                search:null,
                excel: null

              },
              rows: [],
              page: 1,
              per_page: 10,
              filterData: {
                  startDate: null,
                  endDate: null
              }
          }
      },
      methods:{
        getDate(datetime) {
                let date = new Date(datetime).toJSON().slice(0,10).replace(/-/g,'/')
                return date
            },
          updateValues() {
            this.getPosts()
          },
          toggleCheckbox(user) {
                user.status = !user.status
                let status = user.status ? 1 : 0;
                axios.post(`/builder/changeStatus/`+user.id+'/'+status).then(function(response){

                  console.log(response);

                }.bind(this));
              },

              getPosts(start, end,excel) {
             this.dateRange.excel=excel;
             this.dateRange.search=$('#Datatable_wrapper input[type=search]').val();
              if(excel == 'excel') {
                window.location.href = `${this.slug}?${$.param(this.dateRange)}`;
                return ;
              }

              $(".preloader").show();
              axios.post(this.slug,this.dateRange).then(function(response){

              $(".preloader").hide();
                  this.rows = response.data;
                  console.log(this.rows);
                   setTimeout(function(){
                    $('#Datatable').DataTable(
                        {
                            pagingType: 'full_numbers',
                              pageLength: 10,
                              processing: true,
                              "order": [[ 0, "desc" ]],

                              dom: 'Bfrtip',
                                  buttons: [],
                                    bRetrieve: true
                        }
                    );
                    //   $('#Datatable').DataTable({
                    //     pagingType: 'full_numbers',
                    //     //pageLength: 10,
                    //     lengthMenu: [
                    //         [10, 25, 50, -1],
                    //         [10, 25, 50, 'All'],
                    //     ],
                    //     "order": [[ 1, "desc" ]],
                    //  });
                    },
                      1000
                      );
              }.bind(this));
          }
      },

      created: function(){
            this.getPosts()
      },
      filters: {
        dateCell (value) {
          let dt = new Date(value)

          return dt.getDate()
        },
        date (val) {
          return val ? val.toLocaleString() : ''
        }
      }
  }
  function formatDate(date) {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;

    return [year, month, day].join('-');
}




  // $(function() {
  //     $('.toggle-class').change(function() {
  //         var status = $(this).prop('checked') == true ? 1 : 0;
  //         var user_id = $(this).data('id');
  //         $.ajax({
  //             type: "POST",
  //             dataType: "json",
  //             url: '/changeStatuss',
  //             data: {'status': status, 'user_id': user_id},
  //             success: function(data){
  //               console.log(data.success)
  //             }
  //         });
  //     })
  //   })

</script>

<style>

.VuePagination {
  text-align: center;
}

.vue-title {
  text-align: center;
  margin-bottom: 10px;
}

.vue-pagination-ad {
  text-align: center;
}

.glyphicon.glyphicon-eye-open {
  width: 16px;
  display: block;
  margin: 0 auto;
}

th:nth-child(3) {
  text-align: center;
}

.VueTables__child-row-toggler {
  width: 16px;
  height: 16px;
  line-height: 16px;
  display: block;
  margin: auto;
  text-align: center;
}

.VueTables__child-row-toggler--closed::before {
  content: "+";
}

.VueTables__child-row-toggler--open::before {
  content: "-";
}


.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

.switch input {
  display: none;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #101010;
}

input:focus + .slider {
  box-shadow: 0 0 1px #101010;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
</style>
